import React, { memo } from 'react';
import * as styles from './styles';
import styled from 'styled-components';
import { useTranslation } from '@sunbit-dev/translations';
import { ILegalSectionProps } from './models';
import { Pages } from '../../constants/wizardSteps';
import { NewLegalText } from '@sunbit-dev/web-ui-lib';

const textKeys = {
  [Pages.EnterPhoneNumber]: 'phone_verification_page',
  [Pages.ChooseYourPlan]: 'choose_your_plan_page',
};
export const LegalSectionSkipLP = styled(
  memo(({ className, currentPageName }: ILegalSectionProps) => {
    const { t } = useTranslation('components', { keyPrefix: 'legal_section_skip_landing_page' });

    const textKey = textKeys[currentPageName];

    if (!textKey) return null;
    return <NewLegalText {...{ className }}>{t(textKey)}</NewLegalText>;
  })
)`
  ${styles.LegalSectionSkipLP}
`;
